import { Link } from "react-router-dom";
import { CircleCheck, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SuccessDialog = ({ ticket, onClose }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`#${ticket}`);
      toast.success("Nomor tiket disalin");
    } catch {
      toast.error("Gagal menyalin nomor tiket");
    }
  };

  return (
    <Dialog open={!!ticket} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md rounded-3xl text-center" data-testid="success-dialog">
        <div className="success-pop mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 ring-8 ring-emerald-50">
          <CircleCheck className="h-9 w-9" />
        </div>
        <DialogHeader className="items-center space-y-2 sm:text-center">
          <DialogTitle className="font-heading text-2xl font-extrabold text-slate-900" data-testid="success-title">
            Pengaduan Berhasil Dikirim!
          </DialogTitle>
          <DialogDescription className="text-center">
            Terima kasih. Pengaduan Anda telah diterima pengurus RT dan akan segera ditindaklanjuti.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-2xl border border-dashed border-emerald-300 bg-emerald-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700">Nomor Tiket Pengaduan</p>
          <div className="mt-1 flex items-center justify-center gap-1">
            <span className="font-heading text-2xl font-extrabold tracking-tight text-slate-900" data-testid="success-ticket-number">
              #{ticket}
            </span>
            <Button type="button" size="icon" variant="ghost" onClick={copy} className="h-8 w-8 text-emerald-700" data-testid="copy-ticket-btn" aria-label="Salin nomor tiket">
              <Copy className="h-4 w-4" />
            </Button>
          </div>
          <p className="mt-1 text-xs text-slate-500">Simpan nomor ini sebagai bukti pengaduan Anda.</p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2">
          <Button asChild variant="outline" className="h-11 rounded-xl font-semibold" data-testid="view-my-complaints-btn">
            <Link to="/pengaduan-saya">Pantau Progres</Link>
          </Button>
          <Button onClick={onClose} className="h-11 rounded-xl bg-slate-900 font-semibold hover:bg-slate-800" data-testid="new-complaint-btn">
            Buat Pengaduan Baru
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
